import { AuthError, EventError } from '@azure/msal-browser';

export const isAuthError = (error: EventError): error is AuthError =>
  (error as AuthError).errorCode !== undefined;
